import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { Wrapper, BarBackdrop, BarLine } from './ProgressBar.elements'

function ProgressBar(props) {
  // Destructure
  const { width, failed, maxWidth } = props

  return (
    <Wrapper maxWidth={maxWidth}>
      <BarBackdrop />
      <BarLine failed={failed} width={width} />
    </Wrapper>
  )
}

// Default Props
ProgressBar.defaultProps = {
  width: '',
  maxWidth: '',
}

// Proptypes Validation
ProgressBar.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  failed: PropTypes.bool,
}

export default ProgressBar
